import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface Role {
  name?: string;
  group?: "admin" | "analyst";
  email?: string;
}
interface IGlobalState {
  editRole?: Role;
}

const initialState = {
  editRole: undefined,
} satisfies IGlobalState as IGlobalState;

export const rolesSlice = createSlice({
  name: "roles",
  initialState,
  reducers: {
    editRole: (state, action: PayloadAction<Role | undefined>) => {
      state.editRole = action.payload;
    },
  },
});
export const selectEditRole = (state: RootState) => state.roles.editRole;
export const { editRole } = rolesSlice.actions;
export type RoleState = ReturnType<typeof rolesSlice.reducer>;
export default rolesSlice.reducer;
